import { useState } from "react";
import { Play } from "lucide-react";

import { cn } from "@/lib/utils";

interface TikTokVideoThumbProps {
  src: string | null;
  title: string;
  /** Sizes the tile; portrait 9:16 like the video itself. */
  className?: string;
}

/**
 * A TikTok video cover with a quiet placeholder for videos TikTok will not
 * hand a cover for (private, removed, or still resolving). The tile is
 * decorative; the row's title link carries the accessible name.
 */
export function TikTokVideoThumb({ src, title, className }: TikTokVideoThumbProps) {
  const [failed, setFailed] = useState(false);
  const base = cn("block shrink-0 overflow-hidden rounded-md bg-muted", className);
  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        title={title}
        loading="lazy"
        onError={() => setFailed(true)}
        className={cn(base, "object-cover")}
      />
    );
  }
  return (
    <span aria-hidden="true" title={title} className={cn(base, "flex items-center justify-center")}>
      <Play className="h-3.5 w-3.5 text-muted-foreground" />
    </span>
  );
}
